//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';

export const getConnectedFacebookPageToken = (state: ICuralateStore) =>
  state.facebookInstagramSettings.connectedFacebookPageToken;

export const getFacebookConnectionData = createSelector(
  getConnectedFacebookPageToken,
  (state: ICuralateStore) => state.facebookInstagramSettings.facebookUserToken,
  (state: ICuralateStore) =>
    state.facebookInstagramSettings.flags.isFetchingConnectedFacebookPageToken,
  (state: ICuralateStore) =>
    state.facebookInstagramSettings.flags.isFetchingFacebookUserToken,
  (
    connectedFacebookPageToken,
    facebookUserToken,
    isFetchingConnectedFacebookPageToken,
    isFetchingFacebookUserToken,
  ) => {
    return {
      connectedFacebookPageToken,
      facebookUserToken,
      isFetchingConnectedFacebookPageToken,
      isFetchingFacebookUserToken,
    };
  },
);
